import "./FindGame.css";
import { redicrectAuth, getPublicGames, joinGame } from "../../api";
import React, { useState, useEffect } from "react";

const JoinGameSection = ({ gameData, onJoin, setOpen }) => {
  console.log(gameData);
  const [insufficientFunds, setInsufficientFunds] = useState(false);
  const [error, setError] = useState("");

  const balance = localStorage.getItem("balance");

  const sendJoinRequest = () => {
    if (Number(balance) < Number(gameData.bet)) {
      setInsufficientFunds(true);
      return;
    }
    setInsufficientFunds(false);
    joinGame(gameData.id, onJoin, setError);
  };

  const onReject = () => {
    setOpen(false);
  };

  const deposit = () => {
    window.location.href = `/walletop`;
  };

  return (
    <div className="overlay">
      <div className="modal">
        <p className="modal-title">
          Join the game with <strong>{gameData.admin}</strong>?
        </p>
        <p className="modal-text">
          The bet is <strong>{parseFloat(gameData.bet).toFixed(2)}</strong> TON
        </p>
        {error && <p className="error-modal">{error}</p>}
        <div className="modal-button-container">
          {insufficientFunds ? (
            <div>
              <div className="error-title">Insufficient funds</div>
              <div className="create-container">
                <button className="create-button" onClick={deposit}>
                  Deposit
                </button>
              </div>
            </div>
          ) : (
            <button
              className="modal-button-primary"
              type="submit"
              onClick={sendJoinRequest}
            >
              Yes
            </button>
          )}

          <button className="modal-button-secondary" onClick={onReject}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

const FindView = ({}) => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [gameData, setGameData] = useState(null);
  const [open, setOpen] = useState(false);
  const balance = localStorage.getItem("balance");

  const onJoin = () => {
    setOpen(false);
    window.location.href = `/game/${gameData.id}`;
  };

  const back = () => {
    window.location.href = `/menu`;
  };

  useEffect(() => {
    if (redicrectAuth()) {
      window.location.href = "/";
    }

    const fetchGames = async () => {
      const callback = (gamesRaw) => {
        const sortedGames = gamesRaw
          .sort((a, b) => {
            if (a.admin > 0 && b.admin <= 0) return -1;
            if (a.admin <= 0 && b.admin > 0) return 1;
            return 0;
          })
          .map((game) => ({
            id: game.id,
            name: names[Math.floor(Math.random() * names.length)],
            admin: game.admin,
            bet: game.bet,
          }));
        setGames(sortedGames);
      };
      try {
        await getPublicGames(callback, setError);
      } catch (err) {
        console.log(err);
        setError("Ошибка загрузки игр");
      } finally {
        setLoading(false);
      }
    };

    fetchGames();
  }, []);

  const joinGame = (game) => {
    setGameData({ id: game.id, admin: game.name, bet: game.bet });
    console.log(`Joining game with ID: ${game.id}`);
    setOpen(true);
  };

  return (
    <div>
      <div className="topbar">
        <button className="backbutton" onClick={back}>
          <img className="imagebackbutton" src="/home.svg" alt="Home" />
        </button>
        <div className="balance-text2">{parseFloat(balance).toFixed(2)}</div>
      </div>

      <div className="games-container">
        {!loading && !error && games.length > 0 && (
          <ul className="games-list">
            {games.map((game) => (
              <li key={game.id} className="game-item">
                <div onClick={() => joinGame(game)} className="game-clickable">
                  <div className="game-text">
                    {parseFloat(game.bet).toFixed(2)}
                  </div>
                  <img className="icon2" src="/ton.png" alt="Icon" />
                  <div className="separator"></div>
                  <div className="game-text">{game.name}</div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
      {loading && <div className="loading-animation">Loading...</div>}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && games.length === 0 && (
        <div className="no-games-message">No public games available</div>
      )}

      {open && (
        <JoinGameSection
          gameData={gameData}
          onJoin={onJoin}
          setOpen={setOpen}
        />
      )}
    </div>
  );
};

const names = [
  "Zaniyah",
  "Myers",
  "Adam",
  "Coleman",
  "Julia",
  "Herman",
  "Juelz",
  "Rowe",
  "Matilda",
  "Brandt",
  "Damir",
  "Magana",
  "Amaris",
  "Watts",
  "Dakota",
  "Powers",
  "Michelle",
  "Jordan",
  "Sawyer",
  "Rowe",
  "Matilda",
  "Webster",
  "Shawn",
  "Giles",
  "Bailee",
  "Cuevas",
  "Brecken",
  "Cordova",
  "Florence",
  "Lester",
  "Lee",
  "Cervantes",
  "Aylin",
  "Myers",
  "Adam",
  "Crosby",
  "Keily",
  "Fitzpatrick",
  "Blaze",
  "Miranda",
  "Amina",
  "Avery",
  "Jakari",
  "Parsons",
  "Maia",
  "Zhang",
  "Isaias",
  "Roth",
  "Elliot",
  "McGee",
  "Conner",
  "Burns",
  "Emerson",
  "Lu",
  "Duncan",
  "McCoy",
  "Mckenzie",
  "Morse",
  "Bode",
  "Alvarez",
  "Leilani",
  "Blevins",
  "Avi",
  "Pearson",
  "Kiara",
  "Farrell",
  "Ty",
  "Jefferson",
  "Julieta",
  "Daniel",
  "Grady",
  "Hensley",
  "Malaya",
  "Gregory",
  "Travis",
  "McMahon",
  "Belen",
  "Terrell",
  "Jaxen",
  "Hunter",
  "Khloe",
  "Pittman",
  "Valentino",
  "Cunningham",
  "Marley",
  "Ventura",
  "Branson",
  "Arias",
  "Aleah",
  "Solis",
  "Ronin",
  "Huff",
  "Karsyn",
  "Perry",
  "Waylon",
  "Barker",
  "Remington",
  "Webster",
  "Shawn",
  "House",
  "Sariah",
  "Wade",
  "Jake",
  "Gentry",
  "Amelie",
  "Byrd",
  "Cristian",
  "Collins",
  "Kinsley",
  "Spears",
  "Ameer",
  "Arroyo",
  "Kyra",
  "Lowe",
  "Julius",
  "Waters",
  "Bristol",
  "Tate",
  "Dalton",
  "Ochoa",
  "Luciana",
  "Maldonado",
  "Javier",
  "Marshall",
  "Adalyn",
  "Ramsey",
  "Luciano",
  "Mays",
  "Denisse",
  "Diaz",
  "Nathan",
  "Nielsen",
  "Vienna",
  "Sparks",
  "Drake",
  "Greer",
  "Reina",
  "Guerra",
  "Leland",
  "Sims",
  "Lena",
  "Chapman",
  "Knox",
  "Leach",
  "Martha",
  "Montgomery",
  "Maximiliano",
  "Powers",
  "Michelle",
  "Deleon",
  "Nasir",
  "Cardenas",
  "Raven",
  "Maxwell",
  "Eden",
  "Hoffman",
  "Aspen",
  "Hinton",
  "Frankie",
  "Gordon",
  "Taylor",
  "Nolan",
  "Maximo",
  "Garrison",
  "Cadence",
  "Lang",
  "Wells",
  "Miranda",
  "Amina",
  "McCann",
  "Heath",
  "Austin",
  "Alivia",
  "O’brien",
  "Riley",
  "Newman",
  "Oaklynn",
  "Owens",
  "Adriel",
  "Macias",
  "Adley",
  "Pena",
  "Marcus",
  "Sellers",
  "Mercy",
  "Poole",
  "Quincy",
  "Nelson",
  "Everly",
  "McMahon",
  "Jakob",
  "Barker",
  "Remington",
  "Pruitt",
  "Gatlin",
  "Hammond",
  "Holly",
  "Hartman",
  "Baker",
  "Wilkerson",
  "Janiyah",
  "Pugh",
  "Judson",
  "Palmer",
  "Juniper",
  "Potter",
  "Lucca",
  "Pennington",
  "Yareli",
  "Powers",
  "Sean",
  "Mathews",
  "Sloan",
  "Day",
  "Kayson",
  "Mathis",
  "Anne",
  "Roberts",
  "Josiah",
  "Lewis",
  "Ellie",
  "Sanford",
  "Truett",
  "Soto",
  "Brynlee",
  "Person",
  "Moses",
  "Beltran",
  "Kaydence",
  "Pope",
  "Gunnar",
  "Solis",
  "Miracle",
  "Rosario",
  "Jedidiah",
  "Charles",
  "Jenna",
  "Fry",
  "Jacoby",
  "Harrison",
  "Jasmine",
  "Roy",
  "Marcelo",
  "House",
  "Sariah",
  "Huynh",
  "Layton",
  "Cardenas",
  "Raven",
  "Clements",
  "Fisher",
  "Owen",
  "Mikayla",
  "Stevenson",
  "Callan",
  "Blackburn",
  "Frida",
  "Pitts",
  "Trey",
  "Salgado",
  "Avalynn",
  "Summers",
  "Darius",
  "Baldwin",
  "Esmeralda",
  "Hester",
  "Rene",
  "Burgess",
  "Emory",
  "Levy",
  "Harold",
  "Hayes",
  "Iris",
  "Cross",
  "Fabian",
  "Reese",
  "Rosemary",
  "Hartman",
  "Baker",
  "Chan",
  "Hattie",
  "Cobb",
  "Raphael",
  "Watson",
  "Hailey",
  "Garner",
  "Sage",
  "Giles",
  "Bailee",
  "Dickson",
  "Maxton",
  "Hendrix",
  "Zhuri",
  "Sexton",
  "Mylo",
  "Campos",
  "Sutton",
  "Sampson",
  "Cain",
  "Ford",
  "Alexandra",
  "Shields",
  "Devon",
  "Mullins",
  "Maliyah",
  "Villa",
  "Clay",
  "Best",
  "Lexie",
  "Duke",
  "Kalel",
  "Shields",
  "Analia",
  "Welch",
  "Hendrix",
  "Odom",
  "Laylani",
  "Harvey",
  "Cayden",
  "Hodge",
  "Coraline",
  "Meza",
  "Lucian",
  "Zuniga",
  "Leslie",
  "House",
  "Yehuda",
  "Allen",
  "Riley",
  "Montgomery",
  "Maximiliano",
  "Quintana",
  "Kenia",
  "Villa",
  "Clay",
  "French",
  "Lorelai",
  "Avalos",
  "Coen",
  "Chapman",
  "Zuri",
  "Hester",
  "Rene",
  "Mosley",
  "Zaniyah",
  "Alfaro",
  "Xzavier",
  "Olson",
  "Isabel",
  "Barrett",
  "Angelo",
  "Donaldson",
  "Natasha",
  "Randolph",
  "Eugene",
  "Esquivel",
  "Jaylee",
  "Booker",
  "Dominik",
  "Baker",
  "Isla",
  "O’brien",
  "Riley",
  "Rhodes",
  "Tatum",
  "Velazquez",
  "Drew",
  "Bond",
  "Alena",
  "Correa",
  "Zakai",
  "Watkins",
  "Lola",
  "Atkinson",
  "Duke",
  "Velez",
  "Megan",
  "Khan",
  "Kendrick",
  "Duran",
  "Willa",
  "Santana",
  "Mohamed",
  "Leon",
  "Amora",
  "McClure",
  "Reese",
  "McCarthy",
  "Kira",
  "Christian",
  "Ledger",
  "Hale",
  "Brinley",
  "Terrell",
  "Jaxen",
  "Lim",
  "Giavanna",
  "Lara",
  "Caiden",
  "Gill",
  "Jordan",
  "Lloyd",
  "Zaire",
  "Reeves",
  "Lana",
  "Huang",
  "Ayaan",
  "Hammond",
  "Holly",
  "Ball",
  "Shane",
  "Lara",
  "Heidi",
  "Sosa",
  "Emir",
  "Copeland",
  "Dayana",
  "Neal",
  "Kane",
  "Bruce",
  "Marilyn",
  "Meyers",
  "Julien",
  "Schaefer",
  "Mavis",
  "McCann",
  "Heath",
  "Harmon",
  "Maren",
  "Hart",
  "Joel",
  "Hendricks",
  "Dani",
  "Maxwell",
  "Eden",
  "Wheeler",
  "Sydney",
  "Patton",
  "Moises",
  "Best",
  "Lexie",
  "Griffith",
  "Franklin",
  "Powell",
  "Vivian",
  "Williamson",
  "Emerson",
  "Dyer",
  "Estrella",
  "Giles",
  "Kole",
  "Byrd",
  "Giselle",
  "Singleton",
  "Landyn",
  "Clay",
  "Aliana",
  "Garza",
  "Judah",
  "Barton",
  "Danna",
  "Dillon",
  "Alvin",
  "Huynh",
  "Oaklee",
  "Lowery",
  "Jaxxon",
  "Singleton",
  "Malaysia",
  "McClure",
  "Reese",
  "Brooks",
  "Autumn",
  "May",
  "Finley",
  "Mayo",
  "Aarya",
  "Leblanc",
  "Braden",
  "Atkinson",
  "Jazmin",
  "Huber",
  "Mac",
  "Suarez",
  "Jimena",
  "Bradford",
  "Ander",
  "McClain",
  "Marleigh",
  "Middleton",
  "Misael",
  "Nichols",
  "Aliyah",
  "Sharp",
  "Royce",
  "Shields",
  "Analia",
  "Peterson",
  "Santiago",
  "Costa",
];

export default FindView;
